import {auth} from 'main/tools';

const EVENT_TYPES = [
  {value: 'time_off_request', labelKey: 'Time Off Requests', visibilitySetting: 'peopleOffTodayVisibility'},
  {value: 'holiday', labelKey: 'Holidays'},
  {value: 'blocked_date', labelKey: 'Blocked Dates'},
  {value: 'birthday', labelKey: 'Birthdays', visibilitySetting: 'birthdayCelebrationVisibility'},
  {value: 'anniversary', labelKey: 'Anniversaries', visibilitySetting: 'anniversaryCelebrationVisibility'},
  {value: 'first_day', labelKey: 'First Days', visibilitySetting: 'startDateCelebrationVisibility'},
  {value: 'custom_event', labelKey: 'Custom Events'}
];

export function visibleEventTypes() {
  return EVENT_TYPES.filter(({visibilitySetting}) => !visibilitySetting || auth.user[visibilitySetting]);
}
